export default defineNuxtPlugin(() => {
  const loginButton = document.querySelector('.login-button')
  const profileLoader = document.querySelector('.profile-loader')

  const wasLoggedIn = sessionStorage.getItem('wasLoggedIn')

  if (wasLoggedIn) {
    loginButton?.classList.add('hidden')
    profileLoader?.classList.remove('hidden')
  }
  else {
    loginButton?.classList.remove('hidden')
    profileLoader?.classList.add('hidden')
  }
})
